import axios from 'axios';
import {
  isProduction,
  PROD_TRIDENT_API_URL,
  QA_TRIDENT_API_URL,
  PROCESS_RESUME_LINK_PATH,
} from '../constants';

interface ProcessResumeLinkParams {
  appId: string;
  prodTesting?: boolean;
}

interface ProcessResumeLinkResponse {
  reverted: boolean;
}

// Bounded so the spinner gate always fails open within a fixed window even if
// the AWS endpoint hangs (accepts the connection but never responds) rather
// than errors — without a timeout the funnel could otherwise stall forever.
const PROCESS_RESUME_LINK_TIMEOUT_MS = 5000;

export const processResumeLink = async ({
  appId,
  prodTesting,
}: ProcessResumeLinkParams): Promise<ProcessResumeLinkResponse> => {
  const url = isProduction()
    ? `${PROD_TRIDENT_API_URL}${PROCESS_RESUME_LINK_PATH}`
    : `${QA_TRIDENT_API_URL}${PROCESS_RESUME_LINK_PATH}`;
  // Only signal prodTesting on the prodTesting path so the endpoint reads the
  // prod-testing LendAPI key for prod-tenant (prodTestingInQA) apps. Omitted for
  // real production traffic, where the normal key already targets the right tenant.
  const body = prodTesting ? { app_id: appId, prodTesting: true } : { app_id: appId };
  try {
    const result = await axios.post(url, body, { timeout: PROCESS_RESUME_LINK_TIMEOUT_MS });
    return { reverted: Boolean(result.data?.reverted) };
  } catch (error: any) {
    console.error('processResumeLink | Error:', error);
    return { reverted: false };
  }
};
